import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

export function svgToString(svg: React.ReactNode): string {
  return renderToStaticMarkup(<>{svg}</>)
}
